import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    favourites: [],
    searchResults: [],
    isSearching: false
  },

  getters: {
    favourites: state => {
      return state.favourites;
    },

    searchResults: state => {
      return state.searchResults;
    },

    isSearching: state => {
      return state.isSearching;
    }
  },

  mutations: {
    initialiseStore(state) {
      if (localStorage.getItem("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("store")))
        );
      }
    },

    addToFavourites(state, favourite) {
      Vue.set(state.favourites, state.favourites.length, favourite);
    },

    removeFromFavourites(state, favourite) {
      let index = state.favourites.findIndex(f => f.id === favourite.id);
      Vue.delete(state.favourites, index);
    },

    setSearchResults(state, searchResults) {
      state.searchResults = searchResults;
    },

    setIsSearching(state, isSearching) {
      state.isSearching = isSearching;
    }
  }
});

store.subscribe((mutation, state) => {
  localStorage.setItem("store", JSON.stringify(state));
});

export default store;
